import angular from 'angular';

import emoticonize from './emoticonize';
import filterOut from './filterOut';
import formatNumber from './formatNumber';
import highlight from './highlight';
import linky from './linky';
import objectAsArray from './objectAsArray';
import slashme from './slashme';
import startsWith from './startsWith';
import stringSplit from './stringSplit';
import toDate from './toDate';
import toDateLong from './toDateLong';
import toDateMedium from './toDateMedium';
import toDateShort from './toDateShort';
import toDateTime from './toDateTime';
import toDateTimeLong from './toDateTimeLong';
import toTime from './toTime';
import toTimeDay from './toTimeDay';
import toTimeShort from './toTimeShort';
import toTimeVeryShort from './toTimeVeryShort';
import uppercaseFirst from './uppercaseFirst';
import possessive from './possessive';
import displayNumber from './displayNumber';
import moneyDisplayFilter from './moneyDisplayFilter';
import toDuration from './toDuration';
import displayDuration from './displayDuration';
import round from './round';
import hours2Minutes from './hours2Minutes';
import displayTimeOffType from './displayTimeOffType';
import pluralizeFilter from './pluralizeFilter';

const filtersModule = angular.module('components.filters', []);

filtersModule.filter('emoticonize', emoticonize);
filtersModule.filter('filterOut', filterOut);
filtersModule.filter('formatNumber', formatNumber);
filtersModule.filter('highlight', highlight);
filtersModule.filter('linky', linky);
filtersModule.filter('objectAsArray', objectAsArray);
filtersModule.filter('slashme', slashme);
filtersModule.filter('startsWith', startsWith);
filtersModule.filter('stringSplit', stringSplit);
filtersModule.filter('toDate', toDate);
filtersModule.filter('toDateLong', toDateLong);
filtersModule.filter('toDateMedium', toDateMedium);
filtersModule.filter('toDateShort', toDateShort);
filtersModule.filter('toDateTime', toDateTime);
filtersModule.filter('toDateTimeLong', toDateTimeLong);
filtersModule.filter('toTime', toTime);
filtersModule.filter('toTimeDay', toTimeDay);
filtersModule.filter('toTimeShort', toTimeShort);
filtersModule.filter('toTimeVeryShort', toTimeVeryShort);
filtersModule.filter('uppercaseFirst', uppercaseFirst);
filtersModule.filter('possessive', possessive);
filtersModule.filter('displayNumber', displayNumber);
filtersModule.filter('moneyDisplay', moneyDisplayFilter);
filtersModule.filter('toDuration', toDuration);
filtersModule.filter('displayDuration', displayDuration);
filtersModule.filter('round', round);
filtersModule.filter('hours2Minutes', hours2Minutes);
filtersModule.filter('displayTimeOffType', displayTimeOffType);
filtersModule.filter('pluralize', pluralizeFilter);

export default filtersModule.name;
